import SourceEntity from "../../models/SourceEntity";
import { MAX_LOOKUP_LIMIT, DBS } from "../../constants/constants";

function parseEntity(entity) {
  const sourceDict = entity.annotationPublicationSources || {};
  const allSourcePubs = Object.values(sourceDict)
    .filter((x) => Array.isArray(x))
    .map((x) => x.slice(0, MAX_LOOKUP_LIMIT));

  const allPubIds = [].concat(...allSourcePubs).map((x) => String(x));
  const pubIds = [...new Set(allPubIds)].filter(Boolean);
  const idMap = pubIds.reduce((a, i) => a.set(i, new Set()), new Map());

  const sourceMap = Object.entries(sourceDict)
    .map(([source, ids]) => [source, ids.map((x) => String(x))])
    .reduce((a, i) => {
      const [source, ids] = i;
      const dbName = DBS[source];
      if (dbName === null) return a;
      const sourceName = dbName || source;
      ids.filter((x) => a.has(x)).forEach((x) => a.get(x).add(sourceName));
      return a;
    }, idMap);

  return new SourceEntity({ ...entity, pubIds, sourceMap });
}

export default parseEntity;
